import { useEffect, useState, Fragment } from "react";
import { Container, Col, Row, Spinner } from "react-bootstrap";
import { StatRightTopIcon } from "components/widgets/StatRightTopIcon";
import { ProjectsStatsProps } from "types";
import { fetchServerStats } from "data/dashboard/fetchServerStats";
import { useAuth } from "context/AuthContext";

const Dashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState<ProjectsStatsProps[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(user){
      fetchServerStats(user).then((data) => {
        setStats(data);
        setLoading(false);
      });
    }
    
  }, [user]);

  return (
    <Fragment>
      <div className="bg-primary pt-10 pb-21"></div>
      <Container fluid className="mt-n22 px-6">
        <Row>
          <Col lg={12} md={12} xs={12}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h3 className="mb-0 text-white">Server</h3>
              {/* Add buttons or links here if needed */}
            </div>
          </Col>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100 my-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            stats.map((item, index) => (
              <Col xl={3} lg={6} md={12} xs={12} className="mt-6" key={index}>
                <StatRightTopIcon info={item} />
              </Col>
            ))
          )}
        </Row>

        {/* Add other dashboard components below if needed */}
      </Container>
    </Fragment>
  );
};

export default Dashboard;
